import { render, staticRenderFns } from "./Worker.vue?vue&type=template&id=58604056&scoped=true"
import script from "./Worker.vue?vue&type=script&lang=js"
export * from "./Worker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58604056",
  null
  
)

export default component.exports